import { render, staticRenderFns } from "./UserRaisingUpdateQuestionsModal.vue?vue&type=template&id=83fa7072&scoped=true"
import script from "./UserRaisingUpdateQuestionsModal.vue?vue&type=script&lang=js"
export * from "./UserRaisingUpdateQuestionsModal.vue?vue&type=script&lang=js"
import style0 from "./UserRaisingUpdateQuestionsModal.vue?vue&type=style&index=0&id=83fa7072&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83fa7072",
  null
  
)

export default component.exports